import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-window-incorrect-password',
  imports: [TranslatePipe, MatDialogTitle, MatDialogContent, MatDialogActions,MatButtonModule],
  templateUrl: './window-incorrect-password.html',
  styleUrl: './window-incorrect-password.scss'
})
export class WindowIncorrectPassword implements OnInit {
  readonly dialogRef = inject(MatDialogRef<WindowIncorrectPassword>);
  data = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }

  onNoClick(){
    this.dialogRef.close();
  }

  clickIconClose(event: MouseEvent){
    //if(event.layerX > 390 && event.layerX < 417 && event.layerY > 15 && event.layerY < 40){ 
      this.onNoClick();
    //}
  }
}
